/**
 * Format a timestamp with improved readability
 * - If within the last minute: "Now"
 * - If today: "Today HH:MM"
 * - If yesterday: "Yesterday HH:MM"
 * - Otherwise: dd/mm/yyyy HH:MM
 */
export function formatRelativeDateTime(timestamp: number): string {
    const date = new Date(timestamp);
    const now = new Date();

    // Calculate time difference in milliseconds
    const diffMs = now.getTime() - date.getTime();
    const diffMinutes = Math.floor(diffMs / (1000 * 60));

    // If within the last minute, show "Now"
    if (diffMinutes < 1 && diffMs >= 0) {
        return 'Now';
    }

    // Format time as HH:MM
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const timeStr = `${hours}:${minutes}`;

    // Check if it's today
    const isToday =
        date.getDate() === now.getDate() &&
        date.getMonth() === now.getMonth() &&
        date.getFullYear() === now.getFullYear();

    if (isToday) {
        return `Today ${timeStr}`;
    }

    // Check if it's yesterday
    const yesterday = new Date(now);
    yesterday.setDate(yesterday.getDate() - 1);

    const isYesterday =
        date.getDate() === yesterday.getDate() &&
        date.getMonth() === yesterday.getMonth() &&
        date.getFullYear() === yesterday.getFullYear();

    if (isYesterday) {
        return `Yesterday ${timeStr}`;
    }

    // Otherwise, use dd/mm/yyyy HH:MM format
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year} ${timeStr}`;
}
